module.exports = __webpack_public_path__ + "static/media/needy.efde7c84.jpeg";